import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AUTH_GUARD_REDIRECTION_LINK } from '../tokens';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const link = inject(AUTH_GUARD_REDIRECTION_LINK);

  if (!auth.isAuthenticated(true)) {
    auth.signOut();
    router.navigate([link]);
    return false;
  }

  return true;
};
